import { Suspense, type ReactNode } from 'react';

import { NotFoundPage } from './NotFoundPage';

/**
 * Development labs, component previews, and email galleries must never render
 * in production.
 *
 * Under Next this was a server-side `notFound()`, so a production request never
 * received the component tree at all. A static SPA ships one bundle, so the
 * check is build-time instead: `process.env.NODE_ENV` and `VERCEL_ENV` are
 * substituted as literals by Vite, which lets the bundler drop these subtrees
 * from a production build entirely rather than merely hiding them.
 */
export function DevOnlyRoute({ children }: { children: ReactNode }) {
  if (process.env.NODE_ENV === 'production' || process.env.VERCEL_ENV === 'production') {
    return <NotFoundPage />;
  }
  return <Suspense fallback={null}>{children}</Suspense>;
}
